import { create } from "zustand";
import ICoreRoom from "../interfaces/ICoreRoom";
import { normalizeGuid } from "../utils/guidUtils";

/**
 * Room notes from CoreAPI, keyed by the room's normalised ifcguid, which equals its space's globalId.
 * Notes live here, not in the sfp-api model, so a saved note shows at once without refetching the model.
 */
interface RoomNotesState {
    rooms: Record<string, ICoreRoom>;

    setRooms: (rooms: ICoreRoom[]) => void;
    setNote: (globalId: string, note: string | null) => void;
}

export const useRoomNotesStore = create<RoomNotesState>()((set) => ({
    rooms: {},

    setRooms: (rooms) => set({ rooms: Object.fromEntries(rooms.map(r => [r.globalId, r])) }),

    setNote: (globalId, note) => set((state) => {
        const key = normalizeGuid(globalId);
        const room = key ? state.rooms[key] : undefined;
        if (!key || !room) return state;
        return { rooms: { ...state.rooms, [key]: { ...room, note } } };
    }),
}));

// The CoreAPI room matching a space's globalId, if any. Only matched rooms have notes and can be edited.
export const getRoomForSpace = (rooms: Record<string, ICoreRoom>, globalId: string): ICoreRoom | undefined => {
    const key = normalizeGuid(globalId);
    return key ? rooms[key] : undefined;
};
